export default __webpack_public_path__ + "static/media/messages.9dc63a73.svg";